import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import ConfirmarOperacionSolicitud from "../../pages/solicitudes/ConfirmarOperacionSolicitud";
import { trackPromise } from 'react-promise-tracker';
import LimiteTarjetaCredito from "../../generico/Tarjeta/LimiteTarjetaCredito"
import TarjetaCreditoCU from "../../generico/Tarjeta/TarjetaCreditoCU"
import CampoNroTelefono from "../../generico/CampoNroTelefono"
// import InputRange from 'react-input-range';
// import "react-input-range/lib/css/index.css"
import Slider from '@mui/material/Slider';
import SolicitudesService from "../../../services/solicitudes/SolicitudesService";
import Popup from "react-popup";
import { formatoSeparadorMilesValue, phoneNumberValido, phoneFormatter, splitImporte } from "../../generico/utils/FormatoInput";
import DatosSocio from "../../generico/DatosSocio"
import $ from "jquery";
import { mensajeExito } from '../../generico/MensajeSistemaToast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faPaperPlane  } from "@fortawesome/free-solid-svg-icons";
const tokenActivo = sessionStorage.getItem('tieneToken');
export default class TarjetaCredito extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      monto: "",
      limiteSuperior: 30000000,
      itemsConfirm: [],
      tiposTC: [],
      tipo: undefined,
      descripcion: undefined,
      limite: undefined,
      telefono: undefined,
      phoneFormat: undefined,
      montoLimInf: undefined,
      email: undefined
    };

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });




  loadDataConfirm() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.enviar();
      }
    });
    $("#idTCForm").submit(function (e) {

      e.preventDefault();
      $.validator.addMethod(
        "prefijos",
        function (value, element) {
  
          return phoneNumberValido(element.value);
  
        }
      );
      $.validator.addMethod(
        "prefijoMin",
        function (value, element) {
          var tam = phoneFormatter(element.value)
          if (tam.length < 10)
            return false
          return true;
  
        }
      );
      var data = {};
      var dataArray = $('#idTCForm').serializeArray();

      for (var i = 0; i < dataArray.length; i++) {
        //console.log(dataArray[i])
        data[dataArray[i].name] = dataArray[i].value;
        if (dataArray[i].name === "tipo" && dataArray[i].value === "") {
          e.target[0].classList.add("error")
          e.target[0].classList.add("is-invalid")

          e.target[0].name = "tc"
          e.target[0].classList.add("is-invalid")
          var prueba = document.getElementById('prueba')
          prueba.classList.add("prueba")

        }
        if (dataArray[i].name === "tipo" && dataArray[i].value !== "") {
          e.target[0].name = ""
          var prueba = document.getElementById('prueba')
          prueba.classList.remove("prueba")
        }

      }

    }).validate(
      {
        rules: {
          tc: {
            required: true,

          },
          telefono: {
            required: true,
            prefijos: { prefijos: false },
            prefijoMin: { prefijoMin: false },

          },
          monto: {
            required: true,

          },
          correo: {
            email: true,
          },


        },
        messages: {
          tc: {
            required: "Este campo es requerido",

          },
          telefono: {
            required: "Este campo es requerido",
            prefijos: "Número inválido",
            prefijoMin: "Número inválido",

          },
          monto: {
            required: "Este campo es requerido",

          },
          correo: {

            email: "Email inválido",
          },

        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);

        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }

  enviar = () => {

    var _itemsConfirm = [
      { concepto: "Tarjeta", valor: this.state.descripcion },
      { concepto: "Límite de Crédito", valor: formatoSeparadorMilesValue(this.state.monto) + " Gs." },
      { concepto: "Telefono de Contacto", valor: this.state.phoneFormat },

    ];

    if (this.state.email !== undefined && this.state.email !== "")
      _itemsConfirm.push({ concepto: "Correo Electrónico", valor: this.state.email })
    this.setState({ itemsConfirm: _itemsConfirm });
    this.modalCtrlConfirm.click();
  }

  componentDidMount() {
    if (sessionStorage.getItem("msg") !== null) {
      mensajeExito("Solicitud de Tarjeta de Crédito enviada con éxito.");
      sessionStorage.removeItem("msg")
    }
    this.setState({ tiposTC: this.getTiposTarjetas() });

  }
  formatearPhone = (valor) => {
    valor = valor.replace("(", "");
    valor = valor.replace(")", "");
    valor = valor.replace("-", "");

    return valor;

  }
  

  selectorValue = (dataFromChild, valores) => {


    
    var montoLimite = 0;
    if (dataFromChild === "58965710" || dataFromChild === "60204900" || dataFromChild === "60426600") {

      montoLimite = 1000000
    }
    if (dataFromChild === "54186321" || dataFromChild === "51506400") {

      montoLimite = 3000000
    }
    if (dataFromChild === "54028521" || dataFromChild === "53587400" || dataFromChild === "53587401") {

      montoLimite = 10000000
    }
    var montoFormat = formatoSeparadorMilesValue(montoLimite);
    var label = undefined
    if(valores != undefined)
    label = valores.label
    this.setState({
      tipo: dataFromChild,
      limite: montoFormat,
      descripcion: label,
      value: montoLimite,
      montoLimInf: montoLimite,
      monto: montoLimite
    });
    document.getElementById('monto').value = montoFormat;
  };
  changeRangeValue = (e) => {

    if (e.target.vaue < this.state.montoLimInf) {
      this.setState({ value: this.state.montoLimInf, monto: this.state.montoLimInf })
      document.getElementById('monto').value = formatoSeparadorMilesValue(this.state.montoLimInf);
      return
    }
    this.setState({ value: e.target.value, monto: e.target.value })
    document.getElementById('monto').value = formatoSeparadorMilesValue(e.target.value);


  }

  onChangeValue = (e) => {
    var numero = e.target.value
    //console.log(numero)
    var importe = splitImporte(numero);

    if (importe < this.state.montoLimInf) {
      this.setState({ value: this.state.montoLimInf, monto: this.state.montoLimInf })
      document.getElementById('monto').value = formatoSeparadorMilesValue(this.state.montoLimInf);
      return
    }
    if (importe > this.state.limiteSuperior) {
      this.setState({ value: this.state.limiteSuperior, monto: this.state.limiteSuperior })
      document.getElementById('monto').value = formatoSeparadorMilesValue(this.state.limiteSuperior);
      return
    }
    var resultado = (Math.trunc(importe / 1000000) * 1000000)
    this.setState({ value: resultado, monto: resultado })
    document.getElementById('monto').value = formatoSeparadorMilesValue(resultado);

  }
  phoneSelectorValue = (dataFromChild) => {
    this.setState({
      phoneFormat: dataFromChild,
      telefono: this.formatearPhone(dataFromChild)
    });
  };


  inicializarEstados = () => {
    this.setState({
      value: 0,
      monto: "",
      itemsConfirm: [],
      tipo: undefined,
      descripcion: undefined,
      limite: undefined,
      telefono: undefined,
      phoneFormat: undefined,
      montoLimInf: undefined,
      email: undefined
    }, this.enableNext
    );


  }
  enableNext() {
    sessionStorage.setItem("msg", "SI");
    window.location.reload();
   

  }

  limpiarTodo = () => {
    this.inicializarEstados()
  }
  confirmarBtn = () => {
    trackPromise(
      SolicitudesService.confirmarSolicitudTC(this.state.monto, this.state.tipo, this.state.telefono, this.state.email)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codigo === 0) {
            this.limpiarTodo()


          }
          else {
            Popup.create({
              title: "Solicitud de Tarjeta de Crédito",
              content: jsonData.mensaje,
              buttons: {
                right: [{
                  text: 'Aceptar',
                  className: 'success',
                  action: function () {

                    Popup.close();
                  }
                }]
              }
            });
          }
        }

        ));


  }

  getTiposTarjetas() {
    var tarjetas = [];

    trackPromise(
      SolicitudesService.getTiposTarjetas()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);

          if (jsonData.codigo === 0) {
            for (var i = 0; i < jsonData.datos.length; i++) {
              tarjetas.push({
                value: jsonData.datos[i].nroBin,
                label:
                  jsonData.datos[i].descripcion,
              });
            }
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.desRetorno));
            return;
          }
        }

        ));
    return tarjetas;
  }

  render() {
    var montoActual = this.state.monto
    var tarjetas = this.state.tiposTC
    if (tarjetas === undefined) {
      tarjetas = this.getTiposTarjetas
      this.setState({ tiposTC: tarjetas });
    }

    return (
      <div className="content-wrapper">
        <ConfirmarOperacionSolicitud
          idModal="idModalConfirm"
          title="Solicitud de Tarjeta de Créditos"
          items={this.state.itemsConfirm}
          confirmarBtn={this.confirmarBtn.bind(this)}
        />
        <Titulo texto="Solicitud de Tarjeta de Crédito" />
        <section className="content">
          <form id="idTCForm" onSubmit={(e) => {
            e.preventDefault();

          }}>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="card">
                    <div className="card-header">
                      <DatosSocio/>
                    </div>
                    { tokenActivo === "N" &&
                    <div className="col-12">
                      <div className="card card-aviso-completo">
                    <div className="card-header card-aviso">
                      <h3 className="title-aviso">Estimado Socio:</h3>
                    </div>
                    <div className="card-body">
                      <p>Recuerde que firmar el Contrato Único y gestionar su Token, le permitirá acceder a mayores 
                        beneficios y seguridad en sus transacciones. Le esperamos en cualquiera de nuestras Sucursales.</p>
                    </div>
                    </div>
                    </div>}

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-7">
                          {<TarjetaCreditoCU titulo="Tipo de tarjeta" presentacion="SELECT" selectorValue={this.selectorValue.bind(this)} itemSelected={this.state.tipo} tarjetas={tarjetas} />}
                        </div>
                        <div className="col-md-5">
                          <div className="row float-right" style={{ paddingLeft: 8, marginRight: -30 }}>
                            {<LimiteTarjetaCredito limite={this.state.limite} />}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            {/* <InputRange
                              minValue={this.state.montoLimInf}
                              value={this.state.value}
                              maxValue={30000000}
                              step={1000000}
                              formatLabel={value => formatoSeparadorMilesValue(value) + " Gs."}
                              onChange={e => this.changeRangeValue(e)} /> */}

                              <Slider

                              value={this.state.value}
                              min={this.state.montoLimInf}
                              max={30000000}
                              step={1000000}
                              valueLabelDisplay="auto"
                              valueLabelFormat={value => formatoSeparadorMilesValue(value) + " Gs."}
                              onChange={value => this.changeRangeValue(value)}
                              />
                              <label className="input-label-bold">Monto</label>
                            <input id="monto" name="monto" type="text" placeholder="monto a solicitar" style={{textTransform: "lowercase"}}
                             className="form-control input-box texto-maximo" defaultValue={montoActual} onBlur={this.onChangeValue} />
                            <label className="texto-importante">Límite de Crédito (Múltiplos de 1.000.000)</label>
                          </div>
                        </div>
                      </div>
                      <CampoNroTelefono label={"Teléfono del contacto"} phoneSelectorValue={this.phoneSelectorValue.bind(this)} phoneSelector={this.state.phoneFormat} />
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label className="input-label-bold">Correo Electrónico</label>
                            <input type="mail" name="correo" placeholder="email" defaultValue={this.state.email} onChange={(val) => {
                              this.setState({ email: val.target.value });
                            }}
                              className="form-control input-box" style={{textTransform: "lowercase"}} />

                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-lg-10 col-md-8">
                        <label className="input-label-bold-obligatorio">
                          (*) Campos Obligatorios
                      </label> 
                        </div>
                        <div className="col-lg-2 col-md-4">
                        <button className="btn btn-cu-primary float-right" onClick={() => this.loadDataConfirm()}>
                        <FontAwesomeIcon icon={faPaperPlane} /> Enviar
                      </button>
                      <a
                        ref={(a) => (this.modalCtrlConfirm = a)}
                        href="#"
                        hidden
                        id="modalCtrlConfirm"
                        data-toggle="modal"
                        data-target="#idModalConfirm"
                      ></a>
                        </div>
                      </div>
                   
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    );
  }
}
